// The checks on the sign-in and forgot-password pages (views/authentication/login2.js, forgot-password.js), in one
// place so they can be tested. Only that the email looks like an address and that the password is not empty: the
// server decides the rest. Any address the sign-up page takes ("+" in it too) and any password (symbols and spaces too)
// must pass here, or a person who signed up could not sign in.

// something@something.something, no spaces: the same check as the sign-up page (utils/signup.js)
export function looksLikeEmail(email) {
	return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email == null ? '' : email).trim());
}

// What is wrong with the email typed, or null
export function emailProblem(email) {
	if (email == null || String(email).trim() === '') {
		return 'Please enter your email address.';
	}
	return looksLikeEmail(email) ? null : 'Please enter a valid email address.';
}

// What is wrong with the password typed, or null: only that it is empty (no rules on its characters or length)
export function passwordProblem(password) {
	return password == null || String(password) === '' ? 'Please enter your password.' : null;
}
